import React, {useState, useEffect} from 'react';
import { useCookies } from "react-cookie";

export default function Info() {

    const [cookies, setCookie, removeCookie] = useCookies(["token"]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const DURATION = 10;

    const [currentPage, setCurrentPage] = useState(0);
    const [progress, setProgress] = useState(0);
    const [timeLeft, setTimeLeft] = useState(DURATION);
    const [user, setUser] = useState(null);
    const decodeToken = (token) => {
        try {
            const payload = token.split(".")[1];
            return JSON.parse(atob(payload));
        } catch {
            return null;
        }
    };

    // useEffect(() => {
    //     console.log("Page actuelle :", currentPage);
    //
    //     const timer = setTimeout(() => {
    //         setCurrentPage(prev =>
    //             prev === annonces.length - 1 ? 0 : prev + 1
    //         );
    //     }, 10000);
    //
    //     return () => clearTimeout(timer);
    // }, [currentPage]);

    useEffect(() => {
        if (!cookies.token) return;

        const decoded = decodeToken(cookies.token);
        setUser(decoded); // contient { id, username, role, ... }
    }, [cookies.token]);

    const annonces = [
        {
            title: "🌐 Mise à jour du Site en version 4.2A",
            content: (
                <>
                    - Changement des Astuce IA pour une bulle d'information. (Retour IA cet été)<br />
                    - Rework du système de Request.<br />
                    - Optimisation du site.<br />
                    - Ajout d'un système de maintenance du site.<br />
                    - Rework du système de mise à jour de la page Torrent après une maj Python.
                </>
            )
        },
        {
            title: "🤖 Bot Discord",
            content: (
                <>
                    - Refonte du système de requests.<br />
                    - Refonte visuel des requests.<br />
                    - Système de mise en maintenance du bot.
                </>
            )
        },
        {
            title: "🐍 Script Python",
            content: (
                <>
                    - Optimisation des scans torrent.<br />
                    - Refonte du systeme de requests.
                </>
            )
        }
    ];

    const handlePageChange = (index) => {
        setCurrentPage(index);
        setProgress(0);
    };

    useEffect(() => {
        const startTime = Date.now();

        const interval = setInterval(() => {
            const elapsed = (Date.now() - startTime) / 1000;

            // Temps restant
            const remaining = Math.max(0, DURATION - elapsed);
            setTimeLeft(remaining);

            // Progression
            const progressPercent = Math.min(
                (elapsed / DURATION) * 100,
                100
            );
            setProgress(progressPercent);

            // Page suivante
            if (elapsed >= DURATION) {
                clearInterval(interval);
                setProgress(0)

                setCurrentPage(prev =>
                    (prev + 1) % annonces.length
                );
            }
        }, 100);

        return () => clearInterval(interval);
    }, [currentPage]);


    // useEffect(() => {
    //     setProgress(0);
    //
    //     const startTime = Date.now();
    //
    //     const interval = setInterval(() => {
    //         const elapsed = Date.now() - startTime;
    //
    //         const percent = (elapsed / DURATION) * 100;
    //
    //         if (percent >= 100) {
    //             setCurrentPage(prev =>
    //                 (prev - 1) % annonces.length
    //             );
    //
    //             clearInterval(interval);
    //         } else {
    //             setProgress(percent);
    //         }
    //     }, 100);
    //
    //     return () => clearInterval(interval);
    // }, [currentPage]);

    // useEffect(() => {
    //     const nextTimer = setTimeout(() => {
    //         setCurrentPage(prev =>
    //             prev === annonces.length - 1 ? 0 : prev + 1
    //         );
    //     }, DURATION * 1000);
    //
    //     setTimeLeft(DURATION);
    //
    //     const countdown = setInterval(() => {
    //         setTimeLeft(prev => {
    //             if (prev <= 0.1) return 0;
    //             return prev - 0.1;
    //         });
    //     }, 100);
    //
    //     return () => {
    //         clearTimeout(nextTimer);
    //         clearInterval(countdown);
    //     };
    // }, [currentPage, annonces.length]);

    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setCurrentPage(prev =>
    //             prev === annonces.length - 1 ? 0 : prev + 1
    //         );
    //     }, 10000);
    //
    //     return () => clearTimeout(timer);
    // }, [currentPage, annonces.length]);

    return (

        <div className="card">
            <div className="card-header">
                <span className="card-title">
                    Information PZ-Admin 💻
                </span>
            </div>

            <div className="info-card">
                <div key={currentPage} className="info-content">
                    <p>
                        <b>{annonces[currentPage].title}</b>
                        <br/>
                        <br/>
                        {annonces[currentPage].content}
                    </p>
                </div>

                <div className="announcement-footer">

                    <div className="timer-display">
                        Prochaine annonce dans {Math.ceil(timeLeft)}s
                    </div>

                    <div className="segments">
                        {annonces.map((_, index) => (
                            <div
                                key={index}
                                className={`segment ${
                                    index < currentPage
                                        ? "completed"
                                        : index === currentPage
                                            ? "active"
                                            : ""
                                }`}
                                onClick={() => handlePageChange(index)}
                            >
                                {index === currentPage && (
                                    <div
                                        key={currentPage}
                                        className="segment-progress"
                                        style={{width: `${progress}%`}}
                                    />
                                )}
                            </div>
                        ))}
                    </div>

                </div>

                {/*<div className="pagination-container">*/}
                {/*    <div className="progress-bar">*/}
                {/*        <div*/}
                {/*            key={currentPage}*/}
                {/*            className="progress-fill"*/}
                {/*        />*/}
                {/*    </div>*/}

                {/*    <div className="pagination-dots">*/}
                {/*        {annonces.map((_, index) => (*/}
                {/*            <span*/}
                {/*                key={index}*/}
                {/*                className={`dot ${currentPage === index ? "active" : ""}`}*/}
                {/*                onClick={() => setCurrentPage(index)}*/}
                {/*            />*/}
                {/*        ))}*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className="pagination-dots">*/}
                {/*    {annonces.map((_, index) => (*/}
                {/*        <span*/}
                {/*            key={index}*/}
                {/*            className={`dot ${currentPage === index ? "active" : ""}`}*/}
                {/*            onClick={() => setCurrentPage(index)}*/}
                {/*        />*/}
                {/*    ))}*/}
                {/*</div>*/}
            </div>

        </div>

        // <div className="card">
        //     <div className="card-header">
        //         <span className="card-title">Information PZ-Admin 💻</span>
        //         {user?.role === "Admin" && (
        //             <button
        //                 className="refresh-btn"
        //                 onClick={() => null}
        //                 disabled={loading}
        //             >
        //                 {loading ? "Mise à jour..." : "Modifier les informations"}
        //             </button>
        //         )}
        //     </div>
        //
        //     <div style={{width: "100%", height: 250}} className="info-card">
        //         {loading && <p>Chargement...</p>}
        //         {error && <p style={{color: "red"}}>{error}</p>}
        //         {!loading && !error && <p>
        //             <b>Mise a jour version 4.2A</b><br/><br/>
        //             - Changement des Astuce IA pour une bulle d'information. ( Retour IA cette été )<br/>
        //             - Rework du système de Request. Il ne sont maintenant plus suprimé et plus d'information son
        //             enregistrer pour les statistique<br/>
        //             - Rework du système de mise a jour de la page Torrent après une maj python<br/><br/>
        //             Plus quelque petite modification et correction de bug mineur.
        //         </p>}
        //     </div>
        // </div>
    );
}
